"use client";

import Cal from "@calcom/embed-react";
import { useV2Translation } from "@/lib/i18n/use-v2-translation";
import { CAL_NAMESPACE, getCalLink } from "./config";

// `calLink` permet de pointer vers un autre type d'événement que le call de
// découverte par défaut (ex : les pages de proposition pointent vers un point
// technique dédié plutôt que vers le premier contact commercial).
// `locale` force la langue de l'interface Cal.com elle-même (mois, jours de la
// semaine, etc.), indépendamment du texte autour du widget : par défaut elle
// suit `lang` (site principal, bilingue), mais les pages de proposition
// (toujours en français, sans préfixe /fr détectable par `useV2Translation`)
// la fixent explicitement à "fr".
export function CalInlineEmbed({
  calLink,
  locale,
}: { calLink?: string; locale?: string } = {}) {
  const { lang } = useV2Translation();

  return (
    <Cal
      namespace={CAL_NAMESPACE}
      calLink={calLink ?? getCalLink(lang)}
      calOrigin="https://cal.leman-it.com"
      embedJsUrl="https://cal.leman-it.com/embed/embed.js"
      style={{ width: "100%", height: "550px" }}
      config={{
        layout: "month_view",
        theme: "light",
        locale: locale ?? lang,
      }}
    />
  );
}
